import "./style.scss"
import { useDispatch } from "react-redux"
import { useEffect, useRef } from "react";
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import EadlineCom from "../../components/EadlineCom";
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { useState } from "react";
import { incrementByAmount } from "../../store/Header";
import { getBlogsListAPI } from "../../api";
import { useNavigate } from "react-router-dom";
import BlogCom from "../../components/BlogCom";
import ChatCom from "../../components/ChatCom";
import { courseList, teacherList, parentChatList, serviceList } from "./config.js"
const HongKongPage = () => {
    const dispatch = useDispatch()
    const carouselRef = useRef(null);
    const [blogList, setBlogList] = useState(null)
    let colList = ["#C4EFDC", "#F9F3FF", "#E8EBCD"]
    const nav = useNavigate();
    const goMath = (url) => {
        nav(url);
    };
    useEffect(() => {
        dispatch(incrementByAmount(1))
        getBlogsListAPI({ type: '0', page: 1, limit: 10 }).then((res) => {
            setBlogList(res);
        })
    }, []);
    const courseItemCom = (item, index) => {
        return (
            <div key={index} className={[(index + 1) % 2 === 0 ? "dual" : "", "courseItem"].join(" ")} >
                <div className="courseLogo"><img src={item.photo} alt="" /></div>
                <div className="courseTitle">{item.title}</div>
                <div className="courseInfo">{item.content}</div>
            </div>
        )
    }
    const chatUsCom = () => {
        let url = "https://wa.me/8617788052878?text=%E5%92%A8%E8%AF%A21V1%E8%AF%BE%E7%A8%8B";
        return (
            <div className="chatUs" onClick={() => { window.open(url) }}>
                <div className=""><img src="../assets/HK/service.png" alt="" /> 點擊咨詢</div>
            </div>
        );
    }
    const teacherItemCom = (item, index) => {
        return (
            <div key={index} className={['teacherItem', index === 1 ? "higthBox" : ""].join(" ")}>
                <div className="teacherHead" style={{ backgroundColor: colList[index] }}><img src={item.picture} alt="" /></div>
                <div className="teacherContent">
                    <div className="teacherName">
                        {item.name}<span>{item.quality}</span>
                    </div>
                    <div className="teacherInfo">{item.introduce}</div>
                </div>
            </div>
        )
    }
    const serviceContentCom1 = (item, index) => {
        return (
            <div key={index} className={['serviceItem', index % 2 != 0 ? "service1" : ""].join(" ")}>
                <div className="left">
                    <div className="serviceTitle">{item.title}</div>
                    <div className="serviceInfo">{item.content}</div>
                </div>
                <div className="right"> <img src={item.picture} alt="" /></div>
            </div>
        )
    }
    return (
        <div className="hkPage">
            <div className="topBut">
                <button className="but1" onClick={() => { goMath('/hongkong/') }} >香港中文</button>
                <button className="but2" onClick={() => { goMath('/hongkongmaths/') }}>香港数学</button>
                <button className="but2" onClick={() => { goMath('/hongkong-English/') }} >香港英文</button>
            </div>
            <div className="barrn">
                <img className="imgMob" src='../assets/HK/HkBarnMob.png' alt="" />
                <img className="imgPc" src='../assets/HK/HKBarn.png' alt="" />
                <div className="nameTitle">
                    <div>香港地區</div>
                    <div className="englishTitle">Hong Kong China</div>
                </div>
            </div>
            <EadlineCom name="課程簡介" />
            <div className="courseMol">
                {
                    courseList.map((item, index) => {
                        return courseItemCom(item, index)
                    })
                }
            </div>
            {chatUsCom()}
            <EadlineCom name="教師資質" />
            <div className="teachers">
                {teacherList.map((item, index) => {
                    return teacherItemCom(item, index)
                })}
            </div>
            <div className="teachers teacherMob">
                <Carousel effect="fade">
                    {teacherList.map((item, index) => {
                        return teacherItemCom(item, index)
                    })}
                </Carousel>
            </div>
            {chatUsCom()}
            <div className="teacherAptitude">
                <EadlineCom name="教師資質" />
                <div className="aptitudeImg">
                    <img className="aptitudePc" src="../assets/HK/aptitudeImg.png" alt="" />
                    <img className="aptitudeMob" src="../assets/HK/aptitudeImgMob.png" alt="" />
                </div>
                {chatUsCom()}
            </div>
            <EadlineCom name="家長與老師互動" />
            <div className="service">
                <div className="arrow" onClick={() => { carouselRef.current.prev() }}><LeftOutlined /> </div>
                <div className="interact">
                    <div>
                        <Carousel effect="fade" autoplay dots={true} ref={carouselRef}>
                            {parentChatList.map((item, index) => (
                                <div className="swiperImg" key={index} >
                                    <img className="talkImg" src={item.picture} alt="" />
                                </div>))}

                        </Carousel>
                    </div>
                </div>
                <div className="arrow" onClick={() => { carouselRef.current.next() }}>
                    <RightOutlined />
                </div>
            </div>
            {chatUsCom()}
            <EadlineCom name="博客" />
            {
                blogList != null ? <BlogCom data='0' blogLists={blogList} /> : null
            }
            <EadlineCom name="服務内容" />
            <div className="serviceContent">
                {serviceList.map((item, index) => {
                    return serviceContentCom1(item, index)
                })}
            </div>
            {chatUsCom()}
            <div style={{ marginBottom: "30px" }}></div>
            <ChatCom />
        </div >
    )
}
export default HongKongPage;